import { render, staticRenderFns } from "./VerListaComprobantes.vue?vue&type=template&id=dbb661b6"
import script from "./VerListaComprobantes.vue?vue&type=script&lang=js"
export * from "./VerListaComprobantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports